import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { PageHeader, Toast } from "@/components/Layout";
import api from "@/lib/api";

const errText = (e) => e?.response?.data?.detail || "Eroare";

/** Alegi anul universitar și programul; vezi planurile pe ani de studiu și le creezi (gol sau prin copiere). */
export default function Plans() {
  const [params, setParams] = useSearchParams();
  const nav = useNavigate();
  const [years, setYears] = useState(null);
  const [programs, setPrograms] = useState([]);
  const [plans, setPlans] = useState([]);
  const [msg, setMsg] = useState({ text: "", type: "info" });
  const toast = (text, type = "info") => { setMsg({ text, type }); setTimeout(() => setMsg({ text: "" }), 3000); };
  const yearId = params.get("year") || (years && (years.find(y => y.is_current) || years[0] || {}).id) || "";
  const programId = params.get("program") || "";
  const program = programs.find(p => p.id === programId);

  useEffect(() => {
    api.get("/stat-didactic/years").then(r => setYears(r.data)).catch(() => setYears([]));
    api.get("/stat-didactic/programs").then(r => setPrograms(r.data.filter(p => p.active))).catch(() => {});
  }, []);
  const loadPlans = () => (programId && yearId)
    ? api.get("/stat-didactic/plans", { params: { program_id: programId, year_id: yearId } }).then(r => setPlans(r.data)) : setPlans([]);
  useEffect(() => { loadPlans(); }, [programId, yearId]);

  const create = async (studyYear, copyFrom) => {
    try {
      const r = await api.post("/stat-didactic/plans", { program_id: programId, academic_year_id: yearId, study_year: studyYear, copy_from_plan_id: copyFrom || null });
      nav(`/stat-didactic/planuri/${r.data.id}`);
    } catch (e) { toast(errText(e), "error"); }
  };
  const setQ = (k, v) => { const p = new URLSearchParams(params); if (v) p.set(k, v); else p.delete(k); setParams(p); };

  if (years === null) return <div>Se încarcă...</div>;
  if (years.length === 0) return <div className="card" style={{ padding: 24 }}>Nu există niciun an universitar. Creează-l din <Link to="/stat-didactic/ani">Ani universitari</Link>.</div>;
  const byYear = Object.fromEntries(plans.map(p => [p.study_year, p]));
  const prevPlans = plans.filter(p => p.discipline_count > 0);
  return (
    <>
      <PageHeader title="Planuri de învățământ" subtitle="Disciplinele fiecărui an de studiu, cu orele pe semestru și creditele" />
      <Toast msg={msg.text} type={msg.type} />
      <div className="te-filters" style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
        <div><label className="label">An universitar</label>
          <select className="select" value={yearId} onChange={e => setQ("year", e.target.value)} data-testid="sfd-plans-year">
            {years.map(y => <option key={y.id} value={y.id}>{y.name}{y.is_current ? " (curent)" : ""}</option>)}</select></div>
        <div style={{ minWidth: 280 }}><label className="label">Program de studii</label>
          <select className="select" value={programId} onChange={e => setQ("program", e.target.value)} data-testid="sfd-plans-program">
            <option value="">— alege —</option>{programs.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}</select></div>
      </div>
      {!program ? (
        <div className="card" style={{ padding: 24, color: "#64748B" }}>
          {programs.length === 0 ? <>Nu există programe de studii. Adaugă-le din <Link to="/stat-didactic/programe">Programe de studii</Link>.</> : "Alege un program ca să vezi planurile lui."}
        </div>
      ) : (
        <div className="card">
          <table className="tbl">
            <thead><tr><th>An de studiu</th><th>Discipline</th><th></th></tr></thead>
            <tbody>{Array.from({ length: program.duration_years }, (_, i) => i + 1).map(n => {
              const pl = byYear[n];
              return (
                <tr key={n} data-testid={`sfd-plan-row-${n}`}>
                  <td style={{ fontWeight: 700 }}>Anul {n}</td>
                  <td>{pl ? `${pl.discipline_count} discipline` : <span style={{ color: "#94A3B8" }}>— fără plan —</span>}</td>
                  <td style={{ display: "flex", gap: 6, justifyContent: "flex-end", flexWrap: "wrap" }}>
                    {pl ? <Link className="btn btn-primary" style={{ padding: "3px 10px", fontSize: 12 }} to={`/stat-didactic/planuri/${pl.id}`}>Deschide</Link>
                        : <>
                            <button className="btn btn-primary" style={{ padding: "3px 10px", fontSize: 12 }} onClick={() => create(n)} data-testid={`sfd-plan-create-${n}`}>Creează plan</button>
                            {prevPlans.length > 0 && <button className="btn btn-secondary" style={{ padding: "3px 10px", fontSize: 12 }} onClick={() => create(n, prevPlans[0].id)}>Pornește de la planul anului {prevPlans[0].study_year}</button>}
                          </>}
                  </td>
                </tr>);
            })}</tbody>
          </table>
        </div>
      )}
    </>
  );
}
